import React, { memo, useCallback } from 'react';
import { cx } from '@emotion/css';
import ClearIcon from '@mui/icons-material/Clear';
import { IconButton } from '../../../../../atoms';
import { useStyles } from './DatePickerClearIcon.styles';
export const DatePickerClearIcon = memo(function (props) {
    const classes = useStyles();
    const handleClearIconMouseDown = useCallback((event) => {
        event.preventDefault();
    }, []);
    return (React.createElement(IconButton, { className: cx(props.className, classes.root), id: props.id },
        React.createElement(ClearIcon, { fontSize: "small", onClick: props.onClick, onMouseDown: handleClearIconMouseDown })));
});
//# sourceMappingURL=DatePickerClearIcon.js.map